import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export const useDeleteAnnouncement = ({
    onSuccess,
    onError,
}: {
    onSuccess?: () => void;
    onError?: (err: unknown, key: string) => void;
}) => {
    const {
        trigger: triggerDeleteAnnouncement,
        isMutating: isLoadingDeleteAnnouncement,
    } = useSWRMutation(
        "/api/notification-management/v1/announcements",
        (
            url: string,
            {
                arg,
            }: {
                arg: { announcementId: string };
            }
        ) =>
            fetcher(`${url}/${arg.announcementId}`, {
                options: {
                    method: API_REST_METHODS.DELETE,
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerDeleteAnnouncement,
        isLoadingDeleteAnnouncement,
    };
};
